<template>
  <div>
    <!-- Personnalisation des prompts -->
    <el-form-item v-if="hasOptionIaAndPersoPrompt">
      <el-row :gutter="24">
        <el-col :span="18">
          <el-select
              ref="promptSelect"
              v-model="selectedPrompt"
              filterable
              :placeholder="$t('prompt.selectedPrompt')"
              style="margin-bottom: 15px;"
              @change="handleSelectedPrompt()"
              clearable
              size="medium"
              :disabled="caption && caption.text !== '' || isDisabled || isNetworkLoading">
            <el-option v-for="prompt in filteredAndOrderedPrompts" :key="prompt.id" :label="prompt.titre"
                       :value="prompt.id">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="3">
          <el-tooltip :content="$t('prompt.defineNewInstruction')" placement="top">
            <el-button @click="redirectToPromptsLibraries" type="primary" size="medium" style="margin-bottom: 15px;"
                       :disabled="caption && caption.text !== '' || isDisabled || isNetworkLoading">
              <i class="el-icon-circle-plus-outline" style="font-size: 18px;"></i>
            </el-button>
          </el-tooltip>
        </el-col>
        <el-col :span="2" class="ml-2">
          <el-tooltip :content="$t('posts.edit.resetCaption')" placement="top">
            <el-button @click="resetCaption" style="margin-bottom: 15px;" size="medium" :disabled="isDisabled || isNetworkLoading">
              <i class="el-icon-refresh-left" style="font-size: 18px;"></i>
            </el-button>
          </el-tooltip>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="wait-captionIA" v-if="isNetworkLoading">
            <p>{{ $t('posts.IA.textSpinnerIA') }}</p>
            <div>
              <Stretch />
            </div>
          </div>
          <div class="textarea-with-emojis" v-else>
            <el-input :rows="8" type="textarea" :disabled="isDisabled" v-model="captionText" ref="textareaNetwork">
            </el-input>
            <div v-if="!isDisabled && caption">
              <Emoji @addEmoji="addEmoji($event)" class="box-emojis" />
            </div>
          </div>
        </el-col>
      </el-row>
    </el-form-item>

    <!-- OptionIA -->
    <el-form-item v-if="hasOnlyOptionIa">
      <el-row :gutter="24">
        <el-col :span="21">
          <!-- Espace vide pour alignement -->
        </el-col>
        <el-col :span="3">
          <el-tooltip :content="$t('posts.edit.resetCaption')" placement="top">
            <el-button @click="resetCaption" style="margin-bottom: 15px;" :disabled="isDisabled || isNetworkLoading" size="medium">
              <i class="el-icon-refresh-left" style="font-size: 18px;"></i>
            </el-button>
          </el-tooltip>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="wait-captionIA" v-if="isNetworkLoading">
            <p v-if="IAoptionActive">{{ $t('posts.IA.textSpinnerIA') }}</p>
            <div>
              <Stretch />
            </div>
          </div>
          <div class="textarea-with-emojis" v-else>
            <el-input :rows="8" type="textarea" :disabled="isDisabled" v-model="captionText" ref="textareaNetwork">
            </el-input>
            <div v-if="!isDisabled && caption">
              <Emoji @addEmoji="addEmoji($event)" class="box-emojis" />
            </div>
          </div>
        </el-col>
      </el-row>
    </el-form-item>

    <!-- Flux -->
    <el-form-item v-if="hasFlux">
      <el-row :gutter="24">
        <el-col :span="21">
          <!-- Espace vide pour alignement -->
        </el-col>
        <el-col :span="3">
          <el-tooltip :content="$t('posts.edit.resetCaption')" placement="top">
            <el-button @click="resetCaption" style="margin-bottom: 15px;" :disabled="isDisabled || isNetworkLoading" size="medium">
              <i class="el-icon-refresh-left" style="font-size: 18px;"></i>
            </el-button>
          </el-tooltip>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="textarea-with-emojis" v-if="!isNetworkLoading">
            <el-input :rows="8" type="textarea" :disabled="isDisabled" v-model="captionText" ref="textareaNetwork">
            </el-input>
            <div v-if="!isDisabled && caption">
              <Emoji @addEmoji="addEmoji($event)" class="box-emojis" />
            </div>
          </div>
          <div class="wait-captionIA" v-else>
            <p>{{ $t('posts.IA.textSpinnerIA') }}</p>
            <div>
              <Stretch />
            </div>
          </div>
        </el-col>
      </el-row>
    </el-form-item>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getDiffuseur } from '@/helpers/functions/diffuseur'
import Emoji from '@/components/emojis/Emoji.vue'
import Stretch from '@/components/spinners/Stretch.vue'
import { CREATE } from '@/helpers/constantes/promptConstants'
import { $t } from '@/i18n'
import { needsSocialNetworkSource } from '@/helpers/functions/socialCaptionFlux'

export default {
  name: 'PostContentEditor',
  components: {
    Emoji,
    Stretch
  },
  props: {
    networkName: {
      type: String,
      required: true
    },
    statusPost: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      selectedPrompt: null
    }
  },
  computed: {
    ...mapGetters(['hasOptionIaAndPersoPrompt', 'hasFlux', 'IAoptionActive', 'getSitimmoUser']),
    ...mapGetters('promptLibraries', ['getLibrariePrompt']),
    ...mapGetters('caption', ['getIsLoadingCaption', 'getCaptionByNetwork', 'getIsLoadingCaptionByNetwork']),
    ...mapGetters('postManager', ['getCurrentPost', 'isBienVendu', 'universe']),
    filteredAndOrderedPrompts () {
      if (!this.getLibrariePrompt || this.getLibrariePrompt.length === 0) {
        return []
      }
      const prompts = [...this.getLibrariePrompt]
      const networkName = this.networkName ? this.networkName.toLowerCase() : null

      // Si l'état est "V", mettre les prompts "Biens vendus" en haut de liste
      if (this.getCurrentPost && this.getCurrentPost.etat === 'V') {
        const biensVendusPrompts = prompts.filter(prompt =>
          prompt.titre && prompt.titre.toLowerCase().includes('biens vendus')
        )
        const otherPrompts = prompts.filter(prompt =>
          !biensVendusPrompts.some(bvp => bvp.id === prompt.id)
        )
        return [...biensVendusPrompts, ...otherPrompts]
      }

      // Définir les correspondances entre networkName et les types de prompts
      const networkMapping = {
        instagram: 'instagram',
        facebook: 'facebook',
        gmb: 'gmb',
        google: 'gmb',
        linkedin: 'linkedin'
      }

      const targetNetwork = networkMapping[networkName]

      if (!targetNetwork) {
        return prompts // Si pas de correspondance, retourner tous les prompts
      }

      // Séparer les prompts qui correspondent au réseau actuel et les autres
      const matchingPrompts = prompts.filter(prompt =>
        (prompt.titre && prompt.titre.toLowerCase().includes(targetNetwork)) ||
          (prompt.description && prompt.description.toLowerCase().includes(targetNetwork)) ||
          (prompt.contenu && prompt.contenu.toLowerCase().includes(targetNetwork))
      )

      const otherPrompts = prompts.filter(prompt =>
        !matchingPrompts.some(mp => mp.id === prompt.id)
      )

      // Retourner d'abord les prompts correspondants, puis les autres
      return [...matchingPrompts, ...otherPrompts]
    },
    hasOnlyOptionIa () {
      return this.IAoptionActive && !this.hasOptionIaAndPersoPrompt && !this.hasFlux
    },
    isDisabled () {
      return this.statusPost === 'published'
    },
    diffuseur () {
      return getDiffuseur(this.networkName, this.universe, this.isBienVendu)
    },
    caption () {
      return this.getCaptionByNetwork(this.diffuseur, this.$route.params.id)
    },
    isNeedSocialNetwork () {
      return needsSocialNetworkSource(this.getSitimmoUser)
    },
    // Computed pour vérifier si ce network spécifique est en cours de chargement
    isNetworkLoading () {
      // Vérifier seulement le loading spécifique à ce network
      return this.getIsLoadingCaptionByNetwork(this.diffuseur, this.$route.params.id)
    },
    captionText: {
      get () {
        const caption = this.getCaptionByNetwork(this.diffuseur, this.$route.params.id)
        return caption ? caption.text : ''
      },
      set (value) {
        // Émet une mutation Vuex pour mettre à jour le texte de la caption
        this.$store.commit('caption/updateCaptionText', {
          diffuseur: this.diffuseur,
          postId: this.$route.params.id,
          text: value
        })
      }
    }
  },
  methods: {
    loadCaptionsForCurrentMode () {
      // Charger les captions selon le mode actuel
      this.$store.dispatch('caption/loadCaptions', {
        universe: this.universe,
        annonceId: this.$route.params.id,
        bienVendu: this.isBienVendu
      })
    },
    loadPromptLibrary () {
      if (this.hasOptionIaAndPersoPrompt) {
        this.$store.dispatch('promptLibraries/loadPrompts')
      }
    },
    addEmoji (emoji) {
      const insertText = emoji
      if (!insertText.length) {
        return
      }
      const textarea = this.$refs.textareaNetwork.$el.querySelector('.el-textarea__inner')

      let cursorIndex = textarea.selectionEnd
      const textIA = this.captionText
      this.captionText = textIA.substring(0, cursorIndex) + insertText + textIA.substring(cursorIndex)
      setTimeout(() => {
        cursorIndex += insertText.length
        textarea.selectionStart = textarea.selectionEnd = cursorIndex
      }, 10)
    },
    resetCaption () {
      const titleDialog = this.hasOptionIaAndPersoPrompt ? $t('prompt.resetPrompt') : $t('posts.adResetDialogTitle')
      const textDialog = this.hasOptionIaAndPersoPrompt ? $t('prompt.resetPromptDialog') : $t('posts.adResetDialog')
      this.$confirm(titleDialog, textDialog, {
        confirmButtonText: $t('prompt.validate'),
        cancelButtonText: $t('prompt.cancel'),
        type: 'info'
      }).then((response) => {
        if (response === 'confirm') {
          // Le loading est maintenant géré directement dans l'action du store
          this.$store.dispatch('caption/resetCaption', {
            network: this.networkName,
            universe: this.universe,
            post: this.getCurrentPost,
            bienVendu: this.isBienVendu
          })
        }
      })
    },
    handleSelectedPrompt () {
      // Forcer la fermeture du dropdown
      this.$nextTick(() => {
        if (this.$refs.promptSelect) {
          this.$refs.promptSelect.blur()
        }
      })
      // S'assurer que la librairie est chargée avant de traiter le prompt
      if (!this.filteredAndOrderedPrompts || this.filteredAndOrderedPrompts.length === 0) {
        this.loadPromptLibrary()
      }

      this.$confirm($t('prompt.selectedPromptIAGenerated'), $t('prompt.selectedPrompt'), {
        confirmButtonText: $t('prompt.validate'),
        cancelButtonText: $t('prompt.cancel'),
        type: 'info'
      })
        .then((response) => {
          if (response === 'confirm') {
            this.$store.dispatch('promptLibraries/findPromptAndSend', {
              promptId: this.selectedPrompt,
              diffuseurName: this.diffuseur,
              post: this.getCurrentPost,
              isNeedSocialNetwork: this.isNeedSocialNetwork
            })
          }
          if (response === 'cancel') {
            this.$message({
              type: 'error',
              message: $t('prompt.selectedFailed')
            })
          }
        }).finally(() => {
          this.selectedPrompt = ''
        })
    },
    redirectToPromptsLibraries () {
      this.$router.push({ path: '/prompt-libraries', query: { action: CREATE, annonceId: this.$route.params.id } })
    }
  },
  mounted () {
    // console.log('PostContentEditor mounted')
    // Charger la librairie de prompts seulement si nécessaire
    this.loadPromptLibrary()
    // Charger les captions automatiquement selon le mode
    this.loadCaptionsForCurrentMode()
  },
  destroyed () {
    this.$store.commit('caption/cleanCaptions')
  }
}
</script>

<style lang="scss" scoped>
.textarea-with-emojis {
  position: relative;
}

.box-emojis {
  position: absolute;
  bottom: 0;
  right: 10px;
  z-index: 100;
}

.wait-captionIA {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 20px;
  min-height: 120px;

  p {
    margin-bottom: 20px;
    color: #1a4a56;
    font-family: "Open Sans", Helvetica, Arial, sans-serif;
    font-weight: 400;
    font-size: 14px;
    line-height: 1.5;
  }

  >div {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .spinner-container {
    display: flex;
    justify-content: center;
    align-items: center;

    i {
      font-size: 24px;
      color: #00a4bd;
      animation: rotating 2s linear infinite;
    }
  }
}

@keyframes rotating {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
